const LOG_MESSAGE = '@message'
const NO_CHANGE = 'noChange'

export enum LOGS_REQUEST {
  Running = 'Running',
  Complete = 'Complete',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
  Timeout = 'Timeout',
}

export const parseLogsResults = (results: any): LogsResult[] => {
  if (!results) {
    return []
  }
  const newResults: any[] = []
  results.flat().forEach((res: any) => {
    if (res.field === LOG_MESSAGE) {
      const json = JSON.parse(res.value)
      const data = filterObjects(json)
      newResults.push(data)
    }
  })
  return newResults
}

const filterObjects = (obj: any) => {
  const result = {}

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key]
      if (value?.action === NO_CHANGE) {
        continue
      }
      result[key] = isObject(value) ? filterObjects(value) : value
    }
  }

  return result
}

const isObject = (value: any) => {
  return typeof value === 'object' && value !== null
}
